document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.header__inline-menu .list-menu > li');
  
  menuItems.forEach(item => {
    const dropdown = item.querySelector('ul');
    if (!dropdown) return;

    item.addEventListener('mouseenter', function() {
      const details = item.querySelector('details');
      if (details) details.setAttribute('open', true);
    });

    item.addEventListener('mouseleave', function() {
      const details = item.querySelector('details');
      if (details) details.removeAttribute('open');
    });
  });
});